import { render, staticRenderFns } from "./EditAttrebutes.vue?vue&type=template&id=57dfc321&scoped=true&"
import script from "./EditAttrebutes.vue?vue&type=script&lang=js&"
export * from "./EditAttrebutes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57dfc321",
  null
  
)

export default component.exports